// components/industry-templates/WellnessEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heart, Flower2, Zap, User } from 'lucide-react';

export const WellnessEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Wellness Programs */}
      {industryData?.wellness_programs && (
        <Card className="border-0 bg-gradient-to-br from-teal-500/20 to-green-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Flower2 className="w-8 h-8" style={{ color: theme.primary }} />
              Wellness Programs
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {industryData.wellness_programs.map((program: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <div className="text-3xl mb-3">🧘</div>
                  <h3 className="text-xl font-bold text-white mb-2">{program.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{program.description}</p>
                  <div className="flex gap-2 flex-wrap">
                    <Badge style={{ backgroundColor: theme.primary }}>{program.duration}</Badge>
                    <Badge variant="outline" className="border-white/20 text-white">{program.instructor}</Badge>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Yoga & Meditation */}
      {industryData?.yoga_sessions && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Heart className="w-6 h-6" style={{ color: theme.primary }} />
              Yoga & Meditation Sessions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.yoga_sessions.map((session: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-bold text-white">{session.type}</h4>
                      <p className="text-sm text-slate-400 mt-1">{session.instructor}</p>
                    </div>
                    <Badge style={{ backgroundColor: theme.primary }}>
                      {session.time}
                    </Badge>
                  </div>
                  {session.level && (
                    <Badge variant="outline" className="border-white/20 text-white mt-2">
                      {session.level}
                    </Badge>
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Nutrition Workshops */}
      {industryData?.nutrition_workshops && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Zap className="w-6 h-6" style={{ color: theme.primary }} />
              Nutrition & Diet Workshops
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {industryData.nutrition_workshops.map((workshop: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg">
                  <h4 className="font-bold text-white mb-2">{workshop.topic}</h4>
                  <p className="text-sm text-slate-400 mb-2">by {workshop.nutritionist}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{workshop.duration}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Wellness Vendors */}
      {industryData?.wellness_vendors && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Wellness Vendors & Exhibits</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {industryData.wellness_vendors.map((vendor: string, idx: number) => (
                <div key={idx} className="p-3 bg-white/5 rounded-lg text-center border border-white/10">
                  <p className="text-white font-medium text-sm">{vendor}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
